export const SEARCH_REGISTRATION_STATUS = 'tin/SEARCH_REGISTRATION_STATUS';
export const CLEAR_REGISTRATION_DATA = 'tin/CLEAR_REGISTRATION_DATA';
